import { BrowserModule }         from '@angular/platform-browser';
import { ApplicationRef, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule, UIView }        from '@uirouter/angular';

import { AppComponent }        from './app.component';
import { AppLiteModule }       from '../app-lite/app.module';
import { LoginModule }         from './login/login.module';
import { PasswordsModule }     from './passwords/passwords.module';
import { QuickbooksModule }    from './quickbooks/quickbooks.module';
import { RouterConfig }        from './routing/router.config';
import { RouterStates }        from './routing/router.states';
import { TwoFactorAuthModule } from './two-factor-auth/two-factor-auth.module';
import { UsersModule }         from './users/users.module';
import { XeroModule }          from './xero/xero.module';

@NgModule({
  providers: [],
  declarations: [
    AppComponent
  ],
  entryComponents: [
    AppComponent
  ],
  imports: [
    BrowserModule,

    UIRouterModule.forRoot({ states: RouterStates, useHash: true, config: RouterConfig }),

    AppLiteModule,
    LoginModule,
    PasswordsModule,
    QuickbooksModule,
    TwoFactorAuthModule,
    UsersModule,
    XeroModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class AppModule {
  ngDoBootstrap (appRef: ApplicationRef) {
    appRef.bootstrap(UIView);
  }
}
